import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown, MenuProps } from "antd";
import * as React from "react";
import { DeleteConfirm } from "src/components/DeleteConfirm";

type PropsClassifierCardActions = {
  deleteTask(): Promise<void>;
};

export const ClassifierCardActions: React.FC<PropsClassifierCardActions> = ({
  deleteTask,
}) => {
  const [deleteMode, setDeleteMode] = React.useState(false);
  const items: MenuProps["items"] = [
    {
      key: "delete",
      danger: true,
      icon: <DeleteOutlined />,
      label: "Удалить",
      onClick: () => setDeleteMode(true),
    },
  ];
  return (
    <>
      <Dropdown trigger={["click"]} menu={{ items }}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
      <DeleteConfirm
        content="Удалить классификатор?"
        open={deleteMode}
        close={() => setDeleteMode(false)}
        task={deleteTask}
      />
    </>
  );
};
